import { useState } from 'react'

export const CreativeBrief = () => {
	const [cbForm, setCbForm] = useState({
		project_title: { value: '', stat: false },
		background_overview: { value: '', stat: false },
		objective: [{ value: '', stat: false }],
		key_message: { value: '', stat: false },
		reason_to_believe: [{ value: '', stat: false }],
		tone_and_style: [{ value: '', stat: false }],
		deliverables: [{ value: '', stat: false }],
		target_audience: [{ value: '', stat: false }],
		timeline: [{ value: '', stat: false }],
		call_to_action: { value: '', stat: false },
	});
	const cbFormDflt = {
		project_title: { value: '', stat: false },
		background_overview: { value: '', stat: false },
		objective: [{ value: '', stat: false }],
		key_message: { value: '', stat: false },
		reason_to_believe: [{ value: '', stat: false }],
		tone_and_style: [{ value: '', stat: false }],
		deliverables: [{ value: '', stat: false }],
		target_audience: [{ value: '', stat: false }],
		timeline: [{ value: '', stat: false }],
		call_to_action: { value: '', stat: false },
	}
	const [cbSubmit, setCbSubmit] = useState({ modal: false, submit: false, success: false })
	const [cbError, setCbError] = useState({ error: false, in_flds: false })
	const [cbLists, setCbLists] = useState([])
	const [cbLoader, setCbLoader] = useState({ list: false })
	return {
		cbForm: {data: cbForm, set: setCbForm},
		cbFormDflt: {data: cbFormDflt},
		cbSubmit: {data: cbSubmit, set: setCbSubmit},
		cbError: {data: cbError, set: setCbError},
		cbLists: {data: cbLists, set: setCbLists},
		cbLoader: {data: cbLoader, set: setCbLoader},
	}
}
